export default
    {
        // url: this.$store.state.http.notasQx.YYYY,
        docsQx: "/quirofano/printDocsQx",
    }
